// import crypto from 'crypto-js';
import SHA256 from 'crypto-js/sha256'
import HmacSHA256 from 'crypto-js/hmac-sha256'
import Hex from 'crypto-js/enc-hex'
import BsUtil from '../BsUtil';
function getDate(timestamp) {
  const date = new Date(timestamp * 1000);
  const year = date.getUTCFullYear();
  const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
  const day = ('0' + date.getUTCDate()).slice(-2);
  return `${year}-${month}-${day}`;
}
// 判断是否是json类型
function isJSON (obj) {
  return BsUtil.isObject(obj) && !obj.length
}
// 模拟浏览器转码
function urlencode(str) {
  str = (str + '').toString();
  return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+').replace(/%3A/g, ':');
}
function main(httpRequestMethod, canonicalUri, canonicalQuery, header) {
  // 密钥参数
  const SECRET_ID = '14f108e92470bdb6a9491fe038b68632036d20f13dbf23d9a935452de698e025';  
  const SECRET_KEY = '60cdbe02dfcceadf4460629a5081a2c91236a578c3f165d422db7b39f67598b1'; 
  const service = 'webh5';
  const version = '1.0.0';
  const timestamp = parseInt(new Date().getTime() / 1000);
  const signedHeaders = 'x-tc-version'; 
  const isGetRq = httpRequestMethod.toUpperCase() === 'GET'
  // 时间处理, 获取世界时间日期
  const date = getDate(timestamp);
  // 处理参数为字符串
  let  canonicalQueryString = '';
  // get请求
  if (isGetRq) {
    // eslint-disable-next-line eqeqeq
    for (const i in canonicalQuery) {
      if (typeof canonicalQuery[i] !== 'undefined') {
        // 参数里面有等号，转成%3D,算加密
        // 是字符串在正则替换，不是原样输出
        canonicalQueryString += i + '=' + (BsUtil.isString(canonicalQuery[i]) ? urlencode(canonicalQuery[i]) : canonicalQuery[i]) + '&';
      }
    }
    // 此处%会被encodeURI转成%25
    canonicalQueryString = encodeURI(canonicalQueryString.substring(0, canonicalQueryString.length - 1)).replace(/%25/g,'%');
  }
  
  // ************* 步骤 1：拼接规范请求串 *************

  // post 请求数据有2种
  // header[httpRequestMethod.toLowerCase()]['Content-Type'] 区分不出来，所以用是否为json区分
  // Content-Type: application/json;charset=UTF-8 =>json类型，需要转字符串
  // Content-Type: application/x-www-form-urlencoded 原样输出
  const payload = isGetRq ? '' : isJSON(canonicalQuery) ? JSON.stringify(canonicalQuery) : canonicalQuery;  // header[httpRequestMethod.toLowerCase()]['Content-Type'] === 'application/x-www-form-urlencoded' ?  : JSON.stringify(canonicalQuery)  // 需要改  body里所有内容转成字符串。get请求的话是空字符串，post请求body内容。
  const hashedRequestPayload = SHA256(payload);
  const canonicalHeaders = '' + 'x-tc-version:' + version + '\n';  // 需要改  请求头里面的 content-type \n host。 \n必填。要求：小写、去掉首尾空格、按照key升序。 形式：key:value。
  const canonicalRequest = httpRequestMethod.toString().toUpperCase() + '\n' +
    canonicalUri + '\n' +
    canonicalQueryString + '\n' +
    canonicalHeaders + '\n' +
    signedHeaders + '\n' +
    hashedRequestPayload;

  // ************* 步骤 2：拼接待签名字符串 *************
  const algorithm = 'TC3-HMAC-SHA256';
  const hashedCanonicalRequest = SHA256(canonicalRequest);// sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(canonicalRequest));
  const credentialScope = date + '/' + service + '/' + 'tc3_request';
  const stringToSign = algorithm + '\n' +
    timestamp + '\n' +
    credentialScope + '\n' +
    hashedCanonicalRequest;

  // ************* 步骤 3：计算签名 *************
 
  const kService = HmacSHA256(service, 'TC3' + SECRET_KEY);
  const kVersion = HmacSHA256(version, kService);
  const kData = HmacSHA256(date, kVersion);
  const kSigning = HmacSHA256('tc3_request', kData);
  const signature = Hex.stringify(HmacSHA256(stringToSign.toString(), kSigning));

  // ************* 步骤 4：拼接 Authorization *************
  const authorization = algorithm + ' ' +
    'Credential=' + SECRET_ID + '/' + credentialScope + ', ' +
    'SignedHeaders=' + signedHeaders + ', ' +
    'Signature=' + signature;

  return {
    'X-TC-Authorization': authorization,
    'X-TC-Timestamp': timestamp.toString(),
    'X-TC-Version': version
  };
}
export default main;
